import { actionsCategories, categoriesColors, defaultCategory, defaultIcons } from './action-category'
import { EmulationCategory, EmulationItem } from './types'
import { ReportFilterValues } from '../../components/filter/types'
import { listToObj } from 'app/modules/shared/helpers'

export function getActionIconData(action: string) {
  for (const [category, actions] of Object.entries(actionsCategories)) {
    if (action in actions) {
      return {
        iconImageClass: actions[action] ?? defaultIcons[category as EmulationCategory],
        iconCategoryClass: categoriesColors[category as EmulationCategory],
      }
    }
  }

  return {
    iconImageClass: defaultIcons[defaultCategory],
    iconCategoryClass: categoriesColors[defaultCategory],
  }
}

export function getActionCategory(action: string) {
  for (const [category, actions] of Object.entries(actionsCategories)) {
    if (action in actions) {
      return category as EmulationCategory
    }
  }

  return defaultCategory
}

export function applyFilter(items: EmulationItem[], filterValues: ReportFilterValues | undefined) {
  if (!Object.keys(filterValues || []).length) {
    return items
  }

  const filter = filterValues as ReportFilterValues
  const categoryFilter = listToObj(filter.category)
  const typeFilter = listToObj(filter.type)
  const sourceFilter = listToObj(filter.source)
  const query = (filter.search?.[0] || '').toLocaleLowerCase()

  const result: EmulationItem[] = []

  for (let i = 0; i < items.length; i++) {
    const item = items[i]
    const skip =
      (filter.category?.length && typeof categoryFilter[item.category] === 'undefined') ||
      (filter.type?.length && typeof typeFilter[item.action] === 'undefined') ||
      (filter.source?.length && typeof sourceFilter[item.source] === 'undefined') ||
      (query &&
        item.action.toLowerCase().indexOf(query) === -1 &&
        item.category.toLowerCase().indexOf(query) === -1 &&
        (!item.description || item.description.toLowerCase().indexOf(query) === -1) &&
        (!item.commandLowerForFilter || item.commandLowerForFilter.indexOf(query) === -1) &&
        (!item.additionalInformation?.Comments?.length ||
          !item.additionalInformation?.Comments.filter(
            (comment: string) => comment.toLocaleLowerCase().indexOf(query) !== -1
          ).length))

    if (!skip) {
      result.push(item)
    }
  }

  return result
}

// Simplify id of emulation item
export function formatId(dataUUID: string) {
  return dataUUID ? dataUUID.replace(/-/g, '') : ''
}
